import styled from 'styled-components';
import { FADED_GREY, VL_BLACK } from '../../utils/colours';

export const MonthHeader = styled.span`
    font-weight: 300;
    color: ${VL_BLACK()};
    width: 150px;
    text-align: center;
    overflow: hidden;
    font-size: 150%;
    min-width: fit-content;
`;

MonthHeader.displayName = 'MonthHeader';

export const MonthHeaderButton = styled.button`
    width: 20px;
    height: 18px;
    background: none;
    padding: 0;
    margin: 0;
    border: none;
    font-weight: 100;
    color: ${VL_BLACK()};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color .3s, transform .3s;

    :not(:disabled) {
        cursor: pointer;
    }

    :disabled {
        opacity: 0;
    }

    @media (hover: hover) {
        :hover {
            transform: translateX(${({ $directionNext }) => $directionNext ? 3 : -3}px);
            color: #464646;
        }
    }

    svg {
        height: 12px;
        width: auto;
    }
`;

MonthHeaderButton.displayName = 'MonthHeaderButton';

export const CalendarGrid = styled.div`
    display: grid;
    width: 100%;
    max-width: 400px;
    grid-template-columns: repeat(7, 14.29%);
    /* Always reserve six weeks so the popup height stays stable across months and time zones. */
    grid-template-rows: 20px repeat(6, 40px);
    justify-content: center;

    font-weight: 100;
    font-size: 80%;
    text-align: center;
    color: ${FADED_GREY};

    // Grid slightly wider than container - not sure why?
    overflow-x: hidden;
`;

CalendarGrid.displayName = 'CalendarGrid';

export const DateCell = styled.div`
    padding: 5px;
    position: relative;
    z-index: 0;
    height: 40px;
    width: 100%;
    margin: auto;

    ${({ $showStartTrail, $colour, $leftEdge }) =>
        $showStartTrail
            ? `
        ::before {
            content: "";
            position: absolute;
            background: ${$colour};
            height: calc(100% - 10px);
            width: 50%;
            top: 5px;
            left: 0;
            z-index: -1;
            opacity: 0.4;
            ${
                $leftEdge
                    ? 'border-radius: 50px 0 0 50px; width: calc(50% - 5px); left: 5px;'
                    : ''
            }
        }
    `
            : ''}

    ${({ $showEndTrail, $colour, $rightEdge }) =>
        $showEndTrail
            ? `
        ::after {
            content: "";
            position: absolute;
            background: ${$colour};
            height: calc(100% - 10px);
            width: 50%;
            top: 5px;
            right: 0;
            z-index: -1;
            opacity: 0.4;
            ${
                $rightEdge
                    ? 'border-radius: 0 50px 50px 0; width: calc(50% - 5px); right: 5px;'
                    : ''
            }
        }
    `
            : ''}
`;

DateCell.displayName = 'DateCell';

export const DateButton = styled.button`
    background: ${({ $selected, $colour }) => ($selected ? $colour : 'none')};
    border: 1px solid
        ${({ $selected, $colour }) => ($selected ? $colour : '#fff0')};
    padding: 0;
    margin: 0;
    font-weight: ${({ $isToday }) => ($isToday ? 300 : 100)};
    aspect-ratio: 1;
    height: 100%;
    text-align: center;
    cursor: pointer;
    color: ${({ $inSelectedMonth, $selected }) =>
        $selected ? '#fff' : $inSelectedMonth ? '#000' : FADED_GREY};
    border-radius: 50px;
    transition: border-color 0.2s;

    @media (hover: hover) {
        :hover:not(:disabled) {
            border-color: ${({ $colour }) => $colour};
        }
    }

    :disabled {
        opacity: 0.2;
        cursor: not-allowed;
    }
`;

DateButton.displayName = 'DateButton';

export const RangeRow = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 70px 1fr 70px;
    grid-template-rows: auto;
    font-size: 90%;
    align-items: center;
`;

RangeRow.displayName = 'DateRangeRow';

export const RangeRowLabel = styled.span`
    font-weight: 300;
    text-align: left;
`;

RangeRowLabel.displayName = 'DateRangeRowLabel';


export const TimeInputField = styled.input.attrs({
    type: 'time',
})`
    font-weight: 100;
    border: 1px solid ${FADED_GREY};
    width: 100%;
    height: 24px;

    &[aria-invalid="true"] {
        border-color: red;
    }
`;

TimeInputField.displayName = 'TimeInput';


export const Text = styled.span`
    font-weight: 100;
    font-size: 90%;
    margin-top: 20px;
`;

Text.displayName = 'Text';
